


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICustomer from '@/store/models/ICustomer';

@Component({ components: { Snackbar } })
export default class DossierInboundsDeliveryNotes extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;
  @Prop({ type: Boolean, required: true }) ShowCustomer!: boolean;
  @Prop({ type: Array, required: true }) CustomerList!: ICustomer[];

  dossierApi = new DossierApi();
  groupedInboundsDeliveryNotes: any[] = [];
  expandedDeliveryNotes: any[] = [];
  loadingInboundDeliveryNotes = false;
  inboundsDeliveryNotesHeaders = [ { text: 'Company Destination', value: 'companyDestinationName' }, { text: 'Warehouse', value: 'warehouseName' }, { text: 'Customer', value: 'customerName' }, { text: 'Code', value: 'code' }, { text: 'Date In', value: 'dateIn' } ];
  inboundsDeliveryNotesDetailHeaders = [ { text: 'Good', value: 'goodName' }, { text: 'Pallet Type', value: 'palletName' }, { text: 'Pallet Amount', value: 'palletsAmount' }, { text: 'Cases/Pallet', value: 'casesPerPallet' }, { text: 'Total Cases', value: 'totalCases' }, { text: 'Goods/Case', value: 'goodsPerCase' }, { text: 'Total Goods', value: 'totalGoods' }, { text: 'Best Before', value: 'bestBeforeDate' } ];

  async mounted() {
      await this.loadInboundDeliveryNotes();
  }

  async loadInboundDeliveryNotes() {
      if (!this.inboundCode) return;
      this.loadingInboundDeliveryNotes = true;

      try {
          const data = await this.dossierApi.DossierReadInboundsDeliveryNotes(this.inboundCode);
          if (this.ShowCustomer === false) {
              data.forEach((i) => {
                  let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                  if (indexCustomer !== -1) {
                      if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                          i.Customer = "";
                      }
                  } else {
                      i.Customer = "";
                  }
              });
          }
          this.groupedInboundsDeliveryNotes = Object.values(
              data.reduce((acc: any, curr: any) => {
                  if (!acc[curr.id]) {
                      acc[curr.id] = {
                          id: curr.id,
                          companyDestinationName: curr.CompanyDestination,
                          warehouseName: curr.Warehouse,
                          customerName: curr.Customer,
                          code: curr.code,
                          dateIn: curr.dateIn,
                          details: []
                      };
                  }
                  acc[curr.id].details.push({
                      goodName: curr.goodName,
                      palletName: curr.palletName,
                      palletsAmount: curr.palletsAmount,
                      casesPerPallet: curr.casesPerPallet,
                      totalCases: curr.totalCases,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods,
                      bestBeforeDate: curr.bestBeforeDate
                  });
                  return acc;
              }, {})
          );
      } catch (err) {
          console.error(err);
      } finally {
          this.loadingInboundDeliveryNotes = false;
      }
  }

  formatDate(dateStr: string) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }
}
